import React from "react";
import PropTypes from 'prop-types';
import AnimateOnScroll from '../components/AnimateOnScroll';
import Bullet from '../components/Bullet';
import { useLanguage } from '../providers/LanguageProvider';

const Curriculum = ({ id }) => {
  const { translations } = useLanguage();
  
  return (
  <section id={id} className="relative py-16 md:py-24 bg-cream">
    {/* Content */}
    <div className="relative z-10 mx-auto max-w-[1240px] px-6">
      <div className="text-start">
        <AnimateOnScroll>
          <h3 className="text-lg md:text-2xl font-bold text-mocha text-center whitespace-pre-line leading-loose">{translations.curriculum.title}</h3>
        </AnimateOnScroll>
        <AnimateOnScroll delay={300}>
          <div className="mt-10 lg:me-36">
            <h3 className="ms-3 text-lg font-bold">{translations.curriculum.subtitle}</h3>
            <ul className="mt-4 space-y-3 text-lg">
              {translations.curriculum.topics.map((topic, index) => (
                <li key={index} className="flex items-center gap-3">
                  <div className="flex-shrink-0"><Bullet /></div>
                  <div>{topic}</div>
                </li>
              ))}
            </ul>
          </div>
        </AnimateOnScroll>
      </div>
    </div>
  </section>
  );
};

Curriculum.propTypes = {
  id: PropTypes.string,
};

export default Curriculum;